/* Keep v2 stamping fee quantities tied to their parent items; retain the existing drawer UI. */
(function () {
  'use strict';
  var source = document.currentScript && document.currentScript.src;
  var baseSource = source && source.replace(/cart-drawer\.js(?=\?|$)/, 'cart-drawer-base-20260907.js');
  var ROOT = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  var latest = null, queue = Promise.resolve(), checkoutBusy = false;
  function read() { return request('cart.js'); }
  function request(path, body) {
    return fetch(ROOT + path, {method:body ? 'POST' : 'GET',headers:{'Content-Type':'application/json','Accept':'application/json'},body:body ? JSON.stringify(body) : undefined}).then(function (res) {
      return res.json().then(function (data) { if (!res.ok) throw new Error(data.description || 'Unable to update the cart.'); return data; });
    });
  }
  function p(item) { return item.properties || {}; }
  function isFee(item) { return p(item)._is_personalization_fee === 'true'; }
  function controlled(item) { return p(item)._emboss_pricing_version === '2'; }
  function hasControlled(cart) { return cart && (cart.items || []).some(controlled); }
  function plan(cart) {
    var items = cart.items || [], updates = {}, additions = [];
    var parents = items.filter(function (i) { return controlled(i) && !isFee(i) && p(i).Personalization === 'Yes'; });
    parents.forEach(function (parent) {
      var props = p(parent), units = Number(props._emboss_units_per_item), total = units * parent.quantity;
      var maximum = Number(props._emboss_volume_count), id = Number(props._emboss_fee_variant);
      if (!Number.isSafeInteger(units) || units < 1 || !Number.isSafeInteger(total) || total < 1 || !id || (maximum > 0 && units > maximum)) throw new Error('Please remove and personalize this item again to confirm its volume selection.');
      var fees = items.filter(function (i) { return controlled(i) && isFee(i) && p(i)._emboss_group === props._emboss_group; });
      var match = fees.find(function (i) { return Number(i.variant_id || i.id) === id; });
      fees.forEach(function (i) { var quantity = i === match ? total : 0; if (i.quantity !== quantity) updates[i.key] = quantity; });
      if (!match) additions.push({id:id,quantity:total,properties:{'For item':parent.product_title || parent.title,Name:props.Name,'Volumes to stamp':props['Volumes to stamp'],_is_personalization_fee:'true',_emboss_group:props._emboss_group,_for_product_id:String(parent.product_id || ''),_for_variant_id:String(parent.variant_id || parent.id),_emboss_name:props.Name,_emboss_language:props.Language,_emboss_foil:props.Foil,_emboss_pricing_version:'2',_emboss_units_per_item:String(units)}});
    });
    items.filter(function (i) { return controlled(i) && isFee(i); }).forEach(function (i) {
      if (!parents.some(function (parent) { return p(parent)._emboss_group === p(i)._emboss_group; })) updates[i.key] = 0;
    });
    return {updates:updates,additions:additions};
  }
  function lockFeeRows(cart) {
    if (!cart) return;
    var fees = new Set((cart.items || []).filter(function (i) { return controlled(i) && isFee(i); }).map(function (i) { return i.key; }));
    document.querySelectorAll('.mc-item[data-item-key], .cd-item[data-key]').forEach(function (row) {
      var key = row.dataset.itemKey || row.dataset.key;
      if (!fees.has(key)) return;
      row.querySelectorAll('[data-qty-change], [data-cd-qty]').forEach(function (button) { button.disabled = true; button.setAttribute('aria-label','Fee quantity follows the stamped item'); });
      row.querySelectorAll('input[data-key]').forEach(function (input) { input.readOnly = true; });
      row.querySelectorAll('[data-remove], [data-cd-remove]').forEach(function (button) { button.disabled = true; button.textContent = 'Linked to stamped item'; });
    });
  }
  function showError(message) {
    var hosts = document.querySelectorAll('.mc-page, [data-cd-foot]');
    hosts.forEach(function (host) {
      var banner = host.querySelector('[data-emboss-cart-error]');
      if (!banner && message) { banner = document.createElement('p'); banner.dataset.embossCartError = ''; banner.setAttribute('role','alert'); host.insertBefore(banner,host.firstChild); }
      if (banner) { banner.textContent = message || ''; banner.hidden = !message; }
    });
  }
  function normalize(cart, attempt) {
    var changes = plan(cart);
    if (!Object.keys(changes.updates).length && !changes.additions.length) return Promise.resolve(cart);
    if (attempt >= 3) return Promise.reject(new Error('Your cart changed while personalization was updating. Please try checkout again.'));
    return (Object.keys(changes.updates).length ? request('cart/update.js',{updates:changes.updates}) : Promise.resolve(cart)).then(function () {
      return changes.additions.length ? request('cart/add.js',{items:changes.additions}) : null;
    }).then(read).then(function (next) { return normalize(next,attempt + 1); });
  }
  function reconcile() {
    var run = queue.catch(function () {}).then(read).then(function (cart) {
      var before = JSON.stringify((cart.items || []).map(function (i) { return [i.key,i.quantity]; }));
      return normalize(cart,0).then(function (next) {
        latest = next; showError('');
        var after = JSON.stringify((next.items || []).map(function (i) { return [i.key,i.quantity]; }));
        if (before !== after) document.dispatchEvent(new CustomEvent('cart:change',{detail:{cart:next,item_count:next.item_count,itemCount:next.item_count,reason:'stamping-fee-sync',source:'jsq-emboss-pricing'}}));
        lockFeeRows(next); return next;
      });
    });
    queue = run.catch(function (err) { showError(err.message); });
    return run;
  }
  window.JSQEmbossCart = {plan:plan,reconcile:reconcile};
  document.addEventListener('cart:change',function (event) {
    var detail = event.detail || {};
    if (detail.cart) { latest = detail.cart; lockFeeRows(latest); }
    if (detail.source !== 'jsq-emboss-pricing' && hasControlled(latest)) reconcile().catch(function () {});
  });
  document.addEventListener('cart:page:rendered',function () { lockFeeRows(latest); });
  document.addEventListener('click',function (event) {
    var button = event.target.closest('[data-qty-change], [data-cd-qty], [data-remove], [data-cd-remove]');
    if (!button || !latest) return;
    var row = button.closest('[data-item-key], .cd-item[data-key]');
    var key = row && (row.dataset.itemKey || row.dataset.key);
    if ((latest.items || []).some(function (i) { return i.key === key && controlled(i) && isFee(i); })) { event.preventDefault(); event.stopImmediatePropagation(); }
  },true);
  function metadata(button) {
    var form = button && button.closest('form'), body = {attributes:{}};
    if (form) {
      new FormData(form).forEach(function (value,key) {
        if (typeof value !== 'string') return;
        if (key === 'note') body.note = value;
        var match = key.match(/^attributes\[([^\]]+)\]$/); if (match) body.attributes[match[1]] = value;
      });
    } else {
      var drawer = button && button.closest('[data-cd-drawer]');
      if (drawer) {
        var gift = drawer.querySelector('[data-cd-gift]'), msg = drawer.querySelector('[data-cd-gift-msg]'), note = drawer.querySelector('[data-cd-note]');
        body.attributes.Gift = gift && gift.checked ? 'Yes — include printed message' : '';
        body.attributes['Gift message'] = gift && gift.checked && msg ? msg.value.trim() : '';
        if (note) body.note = note.value.trim();
      }
    }
    return body;
  }
  function checkout(event,button) {
    if (latest && !hasControlled(latest)) return;
    event.preventDefault(); event.stopImmediatePropagation();
    if (checkoutBusy) return;
    checkoutBusy = true;
    var body = metadata(button);
    if (button) button.setAttribute('aria-busy','true');
    reconcile().then(function () { return request('cart/update.js',body); }).then(function () {
      window.location.href = ROOT + 'checkout';
    }).catch(function (err) { checkoutBusy = false; if (button) button.removeAttribute('aria-busy'); showError(err.message || 'Please refresh your cart before checking out.'); });
  }
  document.addEventListener('click',function (event) {
    var button = event.target.closest('[data-cd-checkout], .mc-checkout, button[name="checkout"], input[name="checkout"], a[href="/checkout"]');
    if (button) checkout(event,button);
  },true);
  document.addEventListener('submit',function (event) {
    if (!(event.target instanceof HTMLFormElement) || !/\/cart\/?(?:\?|$)/.test(event.target.getAttribute('action') || '')) return;
    var button = event.submitter || event.target.querySelector('[name="checkout"]');
    if (button && button.name === 'checkout') checkout(event,button);
  },true);
  function start() { read().then(function (cart) { latest = cart; lockFeeRows(cart); if (hasControlled(cart)) reconcile().catch(function () {}); }).catch(function (err) { console.error('[stamping cart]',err); }); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded',start); else start();
  if (baseSource && baseSource !== source && !window.__jsqDrawerBaseLoaded) {
    window.__jsqDrawerBaseLoaded = true;
    var base = document.createElement('script'); base.src = baseSource + (baseSource.indexOf('?') === -1 ? '?' : '&') + 'ui_revision=abbbb7fc79e9276ad0efb58d303fa06f'; base.defer = true;
    base.onerror = function () { console.error('[cart] Drawer failed to load; the full cart remains available.'); };
    document.head.appendChild(base);
  }
})();
